const LINK_CLASS = 'font-medium text-catering-honey-700 underline underline-offset-2 hover:text-catering-honey-800'

export function internalPath(href) {
  if (typeof href !== 'string') return null
  if (!href.startsWith('/') || href.startsWith('//')) return null
  const path = href.split(/[?#]/)[0]
  return path || null
}

export function resolveBotLinks(html, isAllowed) {
  if (!html || typeof DOMParser === 'undefined') return html
  const body = new DOMParser().parseFromString(html, 'text/html').body
  if (!body) return html

  for (const anchor of Array.from(body.querySelectorAll('a'))) {
    const path = internalPath(anchor.getAttribute('href'))
    if (path && isAllowed(path)) {
      anchor.setAttribute('class', LINK_CLASS)
      anchor.removeAttribute('target')
      anchor.removeAttribute('rel')
    } else {
      anchor.replaceWith(...Array.from(anchor.childNodes))
    }
  }
  return body.innerHTML
}

export function botLinkTarget(event) {
  if (!event || event.defaultPrevented) return null
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return null

  const anchor = event.target?.closest?.('a[href]')
  if (!anchor) return null

  const href = anchor.getAttribute('href')
  return internalPath(href) ? href : null
}
